import React from 'react'
import { Rules } from '@orbital/games-frontend-library'
import GameDescription from './GameDescription'
import { settings, GameplayCustomization } from './CONTENT'

interface DefaultRulesProps {
  gameInfo: {
    minBet: string
    maxBet: string
    currency: string
    precision: number
    game_settings: {
      coefs?: string[]
    } | null
  }
}

export default function DefaultRules({ gameInfo }: DefaultRulesProps) {
  return (
    <>
      <GameDescription gameInfo={gameInfo} />
      <h3>Settings</h3>
      <Rules content={settings} />
      <h3>Gameplay Customization</h3>
      <Rules content={GameplayCustomization} />
    </>
  )
}
